import { v4 as uuid } from "uuid";

import { IBriefResource } from "../../briefs";
import { ICategoryResource } from "../../categories";
import { EntityTypes } from "../../EntityTypes";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValueAsIRI, RelationalValue } from "../../utils/filters";
import { ITag } from "../types";

export type ITagCreateMutationParameters = {
    title: string;
    uuid?: string;
    categories?: RelationalValue<ICategoryResource>[];
    briefs?: RelationalValue<IBriefResource>[];
};

export type ITagCreateMutationResult = ITag;

export const tagCreateMutation: IApiMutationFunction<ITagCreateMutationParameters> = ({
    uuid: providedUuid,
    title,
    categories,
    briefs,
}) => {
    return {
        method: "POST",
        url: "/tags",
        data: {
            title,
            categories: categories?.map(category => mapRelationalValueAsIRI(EntityTypes.CATEGORY, category)),
            briefs: briefs?.map(brief => mapRelationalValueAsIRI(EntityTypes.BRIEF, brief)),
            uuid: providedUuid ?? uuid(),
        },
    };
};

export const useTagCreateMutation = createApiMutationHook<ITagCreateMutationParameters, ITagCreateMutationResult>(
    tagCreateMutation,
);
